module.exports = __webpack_public_path__ + "img/FZLC_12.c1cfed37.jpg";